// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_N1xM1A","icon":"ob_JxcFZS","selected":"ob_lvFNAl","skipBorder":"ob_9N3Z6s","tag":"ob_ywFS4z"};